import classnames from 'classnames'
import DEFAULT_AVATAR from 'images/endUserAvatar.svg'
import React from 'react'

import './style.css'

interface AvatarProps {
  image: string,
  className?: string,
  size?: string
}

const Avatar = ({ image = DEFAULT_AVATAR, className, size = 'LARGE' }: AvatarProps) => (
  <div
    className={classnames('drift-widget-avatar', {
      [className]: !!className,
      "drift-widget-avatar--small": size === "SMALL",
      "drift-widget-avatar--medium": size === "MEDIUM"
    })}
    style={{
      backgroundImage: `url(${image})`
    }}
  />
)

export default Avatar
